<script setup lang="ts">
defineProps<{
  is24h?: boolean
  isOnCallOnly?: boolean
  size?: 'sm' | 'md' | 'lg' | 'xl'
}>()
</script>

<template>
  <UBadge
    :color="is24h ? 'info' : 'error'"
    variant="solid"
    :size="size"
    :leading-icon="is24h ? 'i-lucide-clock' : 'i-lucide-siren'"
    :label="is24h ? 'Nonstop 24/7' : 'Pohotovost'"
    :trailing-icon="isOnCallOnly ? 'i-lucide-phone' : undefined"
  />
</template>
